import React, { useLayoutEffect, useMemo } from 'react';
import { rem } from 'design-system/values';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import StatusBar from 'design-system/StatusBar';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useDefaultHeaderHeight } from 'hooks/useHeaderHeight';
import { AppView } from './AppView';
import { isWeb } from '../constants';
import Spacer from './Spacer';
export const SpaceInviteAction = ({ title, subTitle, icon, children, }) => {
    const colors = useColors();
    const navigation = useMainStackNavigation();
    const defaultHeaderHeight = useDefaultHeaderHeight();
    const { paddingHorizontal } = useAppFrameDimensions(isWeb);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const renderIconComponent = useMemo(() => {
        if (icon) {
            return <View style={styles.iconContainer}>{icon}</View>;
        }
        return null;
    }, [icon]);
    const subTitleContent = useMemo(() => {
        if (typeof subTitle === 'string') {
            return (<Text TextThin-16 centered Secondary>
          {subTitle}
        </Text>);
        }
        return subTitle;
    }, [subTitle]);
    const titleContent = useMemo(() => {
        if (typeof title === 'string') {
            return (<Text Text-24 OffBlack centered>
          {title}
        </Text>);
        }
        return title;
    }, [title]);
    const content = useMemo(() => (<>
        {renderIconComponent}
        {isWeb ? <Spacer h={8}/> : null}
        <View>
          {titleContent ? (<View style={styles.titleContainer}>{titleContent}</View>) : (<Spacer h={16}/>)}
          {subTitleContent}
        </View>
      </>), [renderIconComponent, subTitleContent, titleContent]);
    return (<AppView type="secondary" style={[
            styles.content,
            {
                paddingHorizontal: (paddingHorizontal || 0) + rem(36),
                marginTop: -defaultHeaderHeight,
            },
        ]}>
      <StatusBar barStyle="dark-content" animated/>
      {content}
      {children}
    </AppView>);
};
const styles = StyleSheet.create({
    content: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: rem(36),
    },
    titleContainer: {
        marginBottom: rem(8),
    },
    iconContainer: {
        marginBottom: rem(24),
    },
});
